import React from 'react';
import PropTypes from 'prop-types';
import { actionCreators } from 'react/api/actions/chat';
import { connect } from 'react-redux';

const SupportRequest = ({
  userId,
  chatId,
  responseCall
}) => (
  <div className="GreenmileChatMessageRequestSupportContainer">
    <div className="GreenmileChatMessageRequestSupportIcon" />
    <div className="GreenmileChatMessageRequestSupportMessage">Support Request</div>
    <button
      type="button"
      onClick={() => responseCall({ userId, chatId, accepted: true })}
      className="GreenmileChatMessageRequestSupportConfirmBtn"
    >
      Confirm
    </button>
    <button
      type="button"
      onClick={() => responseCall({ userId, chatId, accepted: false })}
      className="GreenmileChatMessageRequestSupportCancelBtn"
    >
      Cancel
    </button>
  </div>
);

SupportRequest.propTypes = {
  userId: PropTypes.number.isRequired,
  chatId: PropTypes.string.isRequired,
  responseCall: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  acceptCall: actionCreators.acceptCall,
  responseCall: actionCreators.responseCall
};

export default connect(null, mapDispatchToProps)(SupportRequest);
